import GenericDialogue from 'src/components/Dialogue/Dialogue';
import { useEffect } from 'react';
import Loader from 'src/components/Loader';
import Button from 'src/components/Button';
import BulkAddWalkthroughs from 'src/components/BulkOperations/BulkAddWalkthroughs/BulkAddWalkthroughs';
import BulkWalkthroughsSummary from 'src/components/BulkOperations/BulkWalkthroughSummary/BulKWalkthroughSummary';
import { usePropertySuites } from 'src/SharedCustomHooks/UsePropertySuites/usePropertySuites';

interface IBulkAddWalkthroughsDialogueProps {
  isOpen: boolean;
  onClose: () => void;
  userId: string;
  selectedSuiteIds: string[];
  onSave?: (params: any) => void;
  propertyId: any;
  isLoading: any;
  bulkWalkthroughsCreated: any;
  isBulkCreationSuccess: any;
  onSetBulkSuccess: () => void;
}

const BulkAddWalkthroughsDialogue = ({
  isOpen,
  onClose,
  userId,
  selectedSuiteIds,
  onSave,
  propertyId,
  isLoading,
  bulkWalkthroughsCreated,
  isBulkCreationSuccess,
  onSetBulkSuccess,
}: IBulkAddWalkthroughsDialogueProps) => {
  const {
    suites,
    isLoading: suitesLoading,
    error: suitesError,
    refetch: refetchSuites,
  } = usePropertySuites({
    propertyId,
    userId,
    enabled: isOpen,
  });

  useEffect(() => {
    if (!isOpen) {
      onSetBulkSuccess();
    }
  }, [isOpen]);

  const handleClose = () => {
    onSetBulkSuccess();
    onClose();
  };

  const handleRetry = () => {
    refetchSuites();
  };

  if (isLoading || suitesLoading) {
    return (
      <GenericDialogue
        isOpen={isOpen}
        onClose={handleClose}
        title=""
        description=""
      >
        <Loader center={true} />
      </GenericDialogue>
    );
  }

  if (suitesError) {
    return (
      <GenericDialogue
        isOpen={isOpen}
        onClose={handleClose}
        title="Bulk Add Walkthroughs"
        description="Add walkthroughs to multiple suites at once"
      >
        <div className="bulk-add-walkthroughs__error">
          <p>Error: {suitesError}</p>
          <Button
            color="teal"
            size="small"
            label="Retry"
            onClick={handleRetry}
          />
        </div>
      </GenericDialogue>
    );
  }

  return (
    <GenericDialogue
      isOpen={isOpen}
      onClose={handleClose}
      title={
        isBulkCreationSuccess ? 'Walkthroughs Created' : 'Bulk Add Walkthroughs'
      }
      description={
        isBulkCreationSuccess
          ? 'Summary of created walkthroughs'
          : 'Add walkthroughs to multiple suites at once'
      }
    >
      {isBulkCreationSuccess ? (
        <BulkWalkthroughsSummary
          walkthroughs={bulkWalkthroughsCreated}
          onClose={handleClose}
        />
      ) : (
        <BulkAddWalkthroughs
          userId={userId}
          selectedSuiteIds={selectedSuiteIds}
          onSave={onSave}
          suites={suites}
        />
      )}
    </GenericDialogue>
  );
};

export default BulkAddWalkthroughsDialogue;
